<div class="editFormulaDialog" *ngIf="isLoader==false">
  <img class="btnCloseEditDialog" src="../../../assets/cancel-white-18dp.svg" (click)="onCancelClick()" alt="close button">
  <h5 mat-dialog-title class="CenterAlign editFormulaHeader">Edit Detailsssss</h5>
  <div>
    <div mat-dialog-content class="editFormulaBody">
      <div class="row mb-3">
        <div class="col-md-3 col-lg-3">
          <label for="kpiId" class="EditLabel">KPI Id </label>
        </div>
        <div class="col-md-9">
          <label for="kpiId" class="EditLabel">{{data.kpiId}}</label>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 col-lg-3">
          <label for="formulaName" class="EditLabel">Formula Name </label>
        </div>
        <div class="col-md-9">
          <label for="formulaName" class="EditLabel">{{data.formulaName}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-lg-3">
          <label for="formulaNameArea" class="EditLabel">Formula </label>
        </div>
        <div class="col-md-9">
          <textarea type="text" id="formulaNameArea" name="t_Area" class="form-control" [(ngModel)]="data.formula" placeholder="Add Formula"
            required></textarea>
        </div>
      </div>
      <div mat-dialog-actions class="row">
        <div class="col-md-12 text-center">
          <button class="btn btn-primary marginR20 btnUpdate" (click)="OnUpdateClick(data)" tabindex="0">Update</button>
          <button class="btn btn-secondary btnCancel" (click)="onCancelClick()" tabindex="0">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="widgetContainer" *ngIf="isLoader==true">
  <div class="loader"></div>
</div>